import React from "react"

const Banner = ({title}) => (
    <div className="flex items-center justify-center bg-primary">
        <h1 className="text-center p-16 text-4xl font-black text-white" data-sal="fade" data-sal-easing="ease" data-sal-duration="600">{title}</h1>
    </div>
)

export default Banner